import { Box, Paragraph } from '@zillow/constellation-10';
import { ApplicationConfigurationCustomQuestion } from '@zg-rentals/ts-capps-client';
import { useApplicationListing } from '../../../../../contexts/ApplicationContext';
import { getIsCustomQuestionEnabled } from '../../../../../utils/customQuestions';
import type { SupplementalSectionProps } from '../supplementalSections';
import { ContactCard } from './ContactCard';
import { FINANCIAL_CONTACT_TYPES } from './financialContactTypes';

export function FinancialContactsSection({ answers }: SupplementalSectionProps) {
  const { listingOwner } = useApplicationListing();
  const landlordName = listingOwner?.name?.trim() || 'The landlord';
  const hasBusinessAddress = getIsCustomQuestionEnabled(
    answers,
    ApplicationConfigurationCustomQuestion.FINANCIAL_CONTACTS_BUSINESS_ADDRESS,
  );
  const enabledTypes = FINANCIAL_CONTACT_TYPES.filter((type) => getIsCustomQuestionEnabled(answers, type.question));
  const [singleType] = enabledTypes;

  return (
    <>
      <Paragraph textStyle="body-sm" css={{ marginBottom: 'default' }}>
        {enabledTypes.length === 1
          ? `${landlordName} may contact your ${singleType.label.toLowerCase()} to verify your income. This is a part of the screening process.`
          : `${landlordName} requires contact details for your financial advisors to verify your income and financial information as part of their screening process.`}
      </Paragraph>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
        {enabledTypes.map((type) => (
          <ContactCard
            key={type.fieldName}
            fieldName={type.fieldName}
            title={type.label}
            nameLabel={type.nameLabel}
            hasBusinessAddress={hasBusinessAddress}
          />
        ))}
      </Box>
    </>
  );
}
